import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';

@Injectable()
export class GenericService {

    public restPath: String = '';

    constructor(public http: Http) { }

    public getItems(page?: number, limit?: number, filter?: string): Observable<any> {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + localStorage.getItem('lyseoToken'));
        headers.append('Content-Type', 'application/json');
        let options = new RequestOptions({ headers: headers });
        let url = '';
        if (page && limit && page >= 0 && limit > 0) {
            let offset = page * limit;
            url = 'https://www.lyseo.com/api/' + this.restPath + '?limit=' + limit + '&offset=' + offset;
        } else {
            url = 'https://www.lyseo.com/api/' + this.restPath;
        }
        if (filter) {
            if (page && page >= 0) {
                url = url + '&q=' + filter;
            } else {
                url = url + '?q=' + filter;
            }
        }
        return this.http.get(url, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    public getItem(id: String): Observable<any> {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + localStorage.getItem('lyseoToken'));
        headers.append('Content-Type', 'application/json');
        let options = new RequestOptions({ headers: headers });
        let url = 'https://www.lyseo.com/api/' + this.restPath + '/' + id;
        return this.http.get(url, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    
    public extractData(res: Response) {
        const body = res.json();
        return body;
    }

    public handleError(error: any) {
        const errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        return Observable.throw(errMsg);
    }

}